export default __webpack_public_path__ + "static/media/tj.6e245795.svg";